<template>
	<div>
		<v-card>
			<v-card-title>
				<v-icon left color="primary">mdi-cart</v-icon>
				Consulta Plug4Market
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="8">
						<v-text-field solo v-model="search" append-icon="search" label="Pesquisar pelo nome ou CNPJ"
							single-line hide-details></v-text-field>
					</v-col>
					<v-col>
						<DataPicker v-model="datas" @click="loadPix" @close="closeDataPicker" ref="calendario"
							:dense="false" />
					</v-col>
				</v-row>
				<v-row>
					<v-spacer />
					<downloadexcel class="v-btn v-btn--contained theme--light v-size--default primary mr-3 mb-3"
						:data="JSON.parse(JSON.stringify(clientes))" :fields="fieldsExcel" worksheet="relatorio"
						:name="nomeArquivo">
						DOWNLOAD EXCEL
					</downloadexcel>
				</v-row>
				<v-data-table :search="search" :headers="headers" :items="clientes" class="elevation-1"
					:loading="loading" show-expand :single-expand="singleExpand" :expanded.sync="expanded"
					item-key="tradingName">
					<template v-slot:[`item.total`]="{ item }">
						R${{ item.total.toFixed(2).toString().replace('.', ',') }}
					</template>
					<template v-slot:expanded-item="{ headers, item }">
						<td :colspan="headers.length" class="expanded-item">
							<template v-for="(detail, i) in item.details">
								<v-spacer :key="i"/>
								<div :key="i" class="ma-2">
									Mês: {{ detail.month }} |
									Quantidade: {{ detail.ordersAmount }} |
									Preço por pedido: R${{ detail.pricePerOrder.toString().replace('.', ',') }} |
									<strong>Total: R${{ (detail.pricePerOrder * detail.ordersAmount).toFixed(2).toString().replace('.', ',') }}</strong> 
								</div>
							</template>
						</td>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
import DataPicker from '../components/shared/DataPicker.vue'
import downloadexcel from 'vue-json-excel'

export default {
	components: { DataPicker, downloadexcel },
	data: function () {
		return {
			clientes: [],
			datas: [],
			search: '',
			headers: [
				{ text: 'Nome', value: 'tradingName' },
				{ text: 'CNPJ', value: 'cnpj' },
				{ text: 'Quantidade', value: 'ordersAmount', align: 'end' },
				{ text: 'Total', value: 'total', align: 'end' },
				{ text: '', value: 'data-table-expand' },
			],
			fieldsExcel: {
				Nome: 'tradingName',
				CNPJ: 'cnpj',
				Quantidade: 'ordersAmount',
				Total: {
					field: 'total',
					callback: (value) => {
						return 'R$' + value.toFixed(2).toString().replace('.', ',')
					},
				},
			},
			loading: false,
			total: 0,
			singleExpand: false,
			expanded: [],
		}
	},
	computed: {
		nomeArquivo() {
			if (this.datas.length == 1) {
				return `relatorio-marketplace-${this.datas[0]}.xls`
			} else if (this.datas.length == 2) {
				return `relatorio-marketplace-${this.datas[0]}-ate-${this.datas[1]}.xls`
			}
			return 'relatorio-marketplace.xls'
		},
	},
	methods: {
		closeDataPicker() {
			this.datas = []
		},
		async loadPix() {
			try {
				this.loading = true
				const response = await this.axios.get('/marketplace', {
					params: {
						datas: this.datas,
						cnpj: this.search
					},
				})

				this.clientes = response.data.clientes
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style scoped>
.expanded-item {
	text-align: end;
	background: rgb(228, 226, 226);
}
</style>
